Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "Popover1769725574",
  {"root":"Popover1769725574--root","popoverAnimation":"Popover1769725574--popoverAnimation","popoverAnimation-enter":"Popover1769725574--popoverAnimation-enter","popoverAnimation-enter-active":"Popover1769725574--popoverAnimation-enter-active","popoverAnimation-exit":"Popover1769725574--popoverAnimation-exit","popoverAnimation-exit-active":"Popover1769725574--popoverAnimation-exit-active","popoverContent":"Popover1769725574--popoverContent","arrow":"Popover1769725574--arrow","popover":"Popover1769725574--popover","withArrow":"Popover1769725574--withArrow","popoverElement":"Popover1769725574--popoverElement","contentBackgroundColor":"white","contentBorderWidth":"1px","contentBorderStyle":"solid","contentBorderColor":"black","contentBorderRadius":"initial","contentPadding":"initial","contentArrowSize":"5px"},
  "",
  1,
  "Popover1769725574"
);

